<button type="button" class="btn-add-with-list" (click)="toggleFavorite()">
  <span class="material-symbols-outlined" [ngClass]="{ fill: isFavorite }"> favorite </span>
</button>
